const tr = {
  translation: {
    //Menu
    dashboard: "Ana Sayfa",
    reports: "Raporlar",
    contact: "Bize Ulaşın",
    settings: "Ayarlar",
    profile: "Profil",
    logout: "Çıkış",


    //Dashboard
    budget: "Bütçe",
    totalIncome: "Toplam Gelir",
    totalExpense: "Toplam Gider",

    income: "Gelir",
    expense: "Gider",

    expenseStructure: "Gider Yapısı",
    incomeStructure: "Gelir Yapısı",
    today: "Bugün",
    thisWeek: "Bu Hafta",
    thisMonth: "Bu Ay",
    lastMonths: "Son {{monthCount}} Ay",
    thisYear: "Bu Yıl",
    lastRecords: "Son {{lastRecordDayCount}} Kayıt",
    description: "Açıklama",
    actions: "İşlemler",

    // Reports
    all: "Hepsi",
    incomes: "Gelirler",
    expenses: "Giderler",

    //Contact Us
    contactUs: "Bize Ulaş",
    subject: "Konu",
    explanation: "Açıklama",
    submit: "Gönder",
    contactInfo:'İstek, Öneri ve Şikayetlerinizi bize iletin. Uygulamayı geliştirelim',

    // Settings
    currencyType: "Para Birimi",
    update: "Güncelle",

    //Form
    addTransaction: "Yeni Kayıt Ekle",
    editTransaction: "Kaydı Düzenle",

    amount: "Tutar",
    category: "Kategori",
    date: "Tarih",
    type: "Tür",
    save: "Kaydet",
    close: "Kapat",

    typeStatus: "Harcama Nedeni",
    request: "İstek",
    required: "İhtiyaç",

    chooseCategory: "Kaydı Seçiniz",
    chooseTypeStatus: "Harcama Nedeni Seçiniz",

    // Category Types
    food: "Yiyecek & İçecek",
    house: "Konut",
    shopping: "Alışveriş",
    life: "Hayat & Eğlence",
    other: "Diğer",
    salary: "Maaş",

    //Pages:
    showingOf: " Bulunduğun Sayfa {{maxpage}} / ( {{currentPage}} )",

      // SWAL
      areYouSureTitle: "Emin misiniz?",
      warningText: "Bu işlemi geri alamayacaksınız!",
      confirmButtonText: "Evet, silindi!",
      deleted:"Silindi!",
      deletedMessage:"Dosyanız silindi.",
      success: "Başarılı",
      emptyFieldsWarningMessage: "Formda eksik alanlar var!",
      successMessage: "Mesajınız başarıyla gönderildi!",
      failureMessage: "Mesajınız gönderilirken bir sorun oluştu!",
      emptySubjectOrMessageWarning: "Konu yada mesaj boş bırakılamaz!",
      currencyTypeUpdated: 'Para birimi güncellendi',
      currencyTypeUpdateFailled: 'Para birimi güncellenemedi',


    //Login page form
    emailOrPasswordNotEmpty: 'Email yada şifre alanı boş olamaz!',
    emailNotFound: 'Email bulunamadı',
    differentSource: 'Bu mail adresi google giriş yönteminde kullanılmış. Google ile giriş seçeneğini kullanabilirsiniz.',
    passwordDoesntMatch: 'Girilen şifre hatalı',

    //create page
    confirmationPasswordDoesntMatch: 'Şifre eşleşmiyor ',
    passwordOfAtLeast: 'En az 6 karakter şifre girmelisiniz ',
    registerErrorMessage: 'Kayıt yapılırken bir sorun oluştu',
    userRegisterSuccessful: 'Kullanıcı kaydı başarılı şekilde yapıldı. Giriş yapabilirsiniz',
    userExist: 'Kayıt için kullandığınız email adresi daha önce kullanılmıştır.'



  },
};

export default tr;

/*

  */
